import React, { useId, useState } from "react";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import ClearIcon from "@mui/icons-material/Clear";

const Input = ({
  label,
  type = "text",
  disabled = false,
  register,
  error,
  onChange,
  rows = 1,
  maxLength,
  value,
  fullWidth = true,
  onClickCancel,
  ...rest
}) => {
  const id = useId();
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: fullWidth ? "100%" : undefined,
      }}
    >
      {label && (
        <label
          htmlFor={id}
          style={{
            fontWeight: 500,
            fontSize: "14px",
            lineHeight: "20px",
            letterSpacing: "0.01em",
            marginBottom: "6px",
            marginTop: "4px",
            color: error ? "#d32f2f" : "#222",
            userSelect: "none",
            transition: "color 0.2s",
            display: "block",
          }}
        >
          {label}
        </label>
      )}
      <TextField
        id={id}
        type={type === "password" && showPassword ? "text" : type}
        disabled={disabled}
        fullWidth={fullWidth}
        variant="outlined"
        // Use react-hook-form registration for uncontrolled fields
        {...register}
        error={!!error}
        helperText={error || ""}
        inputProps={{
          maxLength: maxLength,
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {type === "password" && (
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={togglePasswordVisibility}
                  onMouseDown={(event) => event.preventDefault()}
                >
                  {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                </IconButton>
              )}
              {onClickCancel && value ? (
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={onClickCancel}
                  style={{ width: 24, height: 24 }}
                >
                  <ClearIcon />
                </IconButton>
              ) : null}
            </InputAdornment>
          ),
        }}
        multiline={rows > 1}
        rows={rows}
        // Remove value and defaultValue unless you are controlling the field outside react-hook-form
        {...rest}
      />
    </div>
  );
};

export default React.memo(Input);
